export default "__VITE_ASSET__DzY5g6_M__"